if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      formData.append('sections', 'cart-drawer');
      config.body = formData;

      fetch(`${routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          const sections = data.sections;
          Object.keys(sections).forEach((key)=>{
            const section = sections[key];
            const content = section;
            const html = new DOMParser().parseFromString(content, 'text/html');
            const fetchedCartDrawer = html.querySelector('cart-drawer');
            if(!fetchedCartDrawer) return;

            const currentCartDrawer = document.querySelector('cart-drawer');
            if(!currentCartDrawer){
              console.log('unable to find existing cart drawer under selector cart-drawer');
              return;
            } else {
              console.log('found cart drawer under selector cart-drawer');
            }

            currentCartDrawer.innerHTML = fetchedCartDrawer.innerHTML;
            currentCartDrawer.initialize();

            const currentItems = fetchedCartDrawer.querySelector('.js-items-count').getAttribute('data-js-current-items');
            const headerBlob = document.querySelector('.js-header-cart-count');
            const bubble = document.querySelector('.cart-count-bubble');

            headerBlob.innerHTML = currentItems;

            if (bubble && +currentItems > 0) {
              bubble.classList.remove('hidden');
            } else if(bubble) {
              bubble.classList.add('hidden');
            }
          });

          const quickview = this.closest('quickview-modal');
          if(quickview) quickview.close();

          const cartDrawerTrigger = document.querySelector(`.js-cart-trigger`);
          if(cartDrawerTrigger){
            const currentCartDrawer = document.querySelector('cart-drawer');
            if(currentCartDrawer){
              currentCartDrawer.open();
            }
          }

        })
        .catch((e) => {
          console.error(e);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
